import { routesPath } from '@router/routes';
import { WithUserRolesHoc } from '@components/HOC/WithUserRoles/WithUserRoles.hoc';
import { UserRoles } from '@dynamika-shared/types/auth';
import { SiteUserLayout } from '@components/SiteUserLayout/SiteUserLayout';
import { Layout } from '@components/Layout/Layout';
import { SiteUserMenu } from '@components/Sidebar/Menu/SiteUserMenu/SiteUserMenu';

import { SelectClinicalTrialForRole } from '@components/LoginSelections/SelectClinicalTrialForRole';
import { SiteUserQueries } from 'src/pages/SiteUser/SiteUserQueries/SiteUserQueries';
import { SiteUserQueriesEntryPage } from 'src/pages/SiteUser/SiteUserQueries/SiteUserQueriesEntryPage';
import { SubjectListEntryPage } from 'src/pages/SiteUser/SubjectList/SubjectListEntryPage';
import { SubjectList } from 'src/pages/SiteUser/SubjectList/SubjectList';
import { SiteUserQueryPage } from 'src/pages/SiteUser/SiteUserQueryPage/SiteUserQueryPage';

export const SiteUserRoutes = [
  {
    path: routesPath.subjectBase,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.SITE]}>
        <SiteUserLayout>
          <SelectClinicalTrialForRole />
        </SiteUserLayout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.subject,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.SITE]}>
        <Layout menuComponent={SiteUserMenu}>
          <SubjectListEntryPage />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.subjectSite,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.SITE]}>
        <Layout menuComponent={SiteUserMenu}>
          <SubjectList />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.subjectQueries,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.SITE]}>
        <Layout menuComponent={SiteUserMenu}>
          <SiteUserQueriesEntryPage />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.subjectQuery,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.SITE]}>
        <Layout menuComponent={SiteUserMenu}>
          <SiteUserQueryPage />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.subjectQueriesSite,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.SITE]}>
        <Layout menuComponent={SiteUserMenu}>
          <SiteUserQueries />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
];
